import { render, staticRenderFns } from "./PaymentComponent.vue?vue&type=template&id=1922deaf&scoped=true"
import script from "./PaymentComponent.vue?vue&type=script&lang=js"
export * from "./PaymentComponent.vue?vue&type=script&lang=js"
import style0 from "./PaymentComponent.vue?vue&type=style&index=0&id=1922deaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1922deaf",
  null
  
)

export default component.exports